import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getSectionHTMLForResource } from '@/scripts/core/cart-functions'
import { getAttributeOrThrow, qsaOptional } from '@/scripts/core/global'

export class CollectionTagFilter extends UcoastEl {
	static htmlSelector = 'collection-tag-filter'
	sectionId: string
	loading = false

	constructor() {
		super()
		this.sectionId = getAttributeOrThrow('data-section-id', this)
		this.addEventListener('click', this.onChipClick.bind(this))
		window.addEventListener('popstate', this.onPopState.bind(this))
	}

	onChipClick(event: MouseEvent) {
		const target = event.target
		if (!(target instanceof HTMLElement)) return
		const chip = target.closest('a[data-tag-chip]')
		if (!(chip instanceof HTMLAnchorElement)) return
		event.preventDefault()
		void this.applyFilter(chip.href)
	}

	onPopState() {
		void this.applyFilter(window.location.href, false)
	}

	async applyFilter(url: string, pushState = true) {
		if (this.loading) return
		this.loading = true
		this.setLoading(true)

		const html = await getSectionHTMLForResource(url, this.sectionId)
		if (html) {
			const doc = new DOMParser().parseFromString(html, 'text/html')
			const newFilter = doc.querySelector(CollectionTagFilter.htmlSelector)
			const newGrid = doc.querySelector('#ProductGridContainer')
			const currentGrid = document.getElementById('ProductGridContainer')

			if (newFilter) {
				const scrollPositions = this.getScrollPositions()
				this.innerHTML = newFilter.innerHTML
				this.restoreScrollPositions(scrollPositions)
			}
			if (newGrid && currentGrid) {
				currentGrid.innerHTML = newGrid.innerHTML
				await window.Ucoast.mediaManager.preloadContainer(currentGrid)
			}
			if (pushState) window.history.pushState({ tagFilter: true }, '', url)
		}

		this.setLoading(false)
		this.loading = false
	}

	setLoading(state: boolean) {
		const grid = document.getElementById('ProductGridContainer')
		if (grid) grid.classList.toggle('uc-grid-loading', state)
	}

	// Each scroll row (skin_types, concerns) resets to scrollLeft 0 when its
	// markup is replaced by the AJAX filter swap. Snapshot scroll position
	// by data-filter-key before the swap and reapply it after, so choosing
	// a filter chip doesn't visually reset the row it lives in.
	getScrollPositions(): Record<string, number> {
		const positions: Record<string, number> = {}
		qsaOptional('[data-filter-key]', this)?.forEach((wrapper) => {
			const key = wrapper.dataset.filterKey
			if (key) positions[key] = wrapper.scrollLeft
		})
		return positions
	}

	restoreScrollPositions(positions: Record<string, number>) {
		qsaOptional('[data-filter-key]', this)?.forEach((wrapper) => {
			const key = wrapper.dataset.filterKey
			if (key && key in positions) wrapper.scrollLeft = positions[key]
		})
	}
}
